import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Col, Container, Form, FormGroup, Input, Label, Row, Card, CardBody, Spinner } from 'reactstrap'
import '../styles/LoginView.css'
import apiLoginService from '../services/apiLoginService'
import logo from '../logo.svg'

const LoginView = () => {
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [errors, setErrors] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const validateForm = () => {
    const newErrors = {}

    if (!username.trim()) {
      newErrors.username = 'El usuario es requerido'
    }

    if (!password.trim()) {
      newErrors.password = 'La contraseña es requerida'
    }

    return newErrors
  }

 const handleLogin = async (e) => {
  e.preventDefault()
  setSubmitted(true)

  setErrors({})
  const newErrors = validateForm()
  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors)
    return
  }

  try {
    setLoading(true) 

    const res = await apiLoginService.login({ username, password })

    if (res?.token) {
      sessionStorage.setItem("token", res.token)
      if (res?.role) {
        sessionStorage.setItem("role", String(res.role).toUpperCase())
      }
      navigate("/index", { replace: true })
    }

    
  } catch (error) {
    const status = error?.status

    if (status === 401) {
      setErrors({ general: "Usuario o contraseña incorrectos" })
      setPassword("")
      return
    }

    // Otros casos: 500, 503, CORS, timeout, caída de servidor...
    setErrors({ general: "Error al conectar con el servidor. Inténtalo de nuevo." })
  } finally {
    setLoading(false)
  }
}


  return (
    <div className="login-container">
      <Container>
       
        <Row className="justify-content-center min-vh-100 align-items-center">
          <Col xs={12} md={5}>
            <Card className="login-card shadow-lg">
              <CardBody className="p-5">
                <div className="text-center mb-5">
                  <img src={logo} alt="Flexihora" className="login-logo" />
                  <h1 className="login-title">Flexihora</h1>
                  <p className="login-subtitle">Gestor de Fichajes</p>
                </div>

                <Form onSubmit={handleLogin}>
                  <FormGroup className="mb-4">
                    <Label for="username" className="fw-bold">
                      Usuario
                    </Label>
                    <Input
                      type="text"
                      id="username"
                      name="username"
                      placeholder="Ingrese su usuario"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      className="login-input"
                      invalid={submitted && !!errors.username}
                    />
                    {submitted && errors.username && (
                      <div className="text-danger small mt-2">{errors.username}</div>
                    )}
                  </FormGroup>

                  <FormGroup className="mb-4">
                    <Label for="password" className="fw-bold">
                      Contraseña
                    </Label>
                    <Input
                      type="password"
                      id="password"
                      name="password"
                      placeholder="Ingrese su contraseña"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="login-input"
                      invalid={submitted && !!errors.password}
                    />
                    {submitted && errors.password && (
                      <div className="text-danger small mt-2">{errors.password}</div>
                    )}
                  </FormGroup>
                  {
                    loading
                      ? (<Spinner color="primary" className="d-block mx-auto my-4" />)
                      : (
                        <Button
                          color="primary"
                          type="submit"
                          className="w-100 login-button fw-bold"
                          size="lg"
                        >
                          Iniciar Sesión
                        </Button>
                      )
                  }
                  
                </Form>

                <div className="text-center mt-4">
                  <small className="text-muted">
                    ¿Problemas al iniciar sesión? Contacte con administración
                  </small>
                </div>
                {errors.general && (
                  <div className="text-danger text-center mt-3">{errors.general}</div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default LoginView
